
import { Button } from '../../../../../../../components/button/button';
import { Card } from '../../../../../../../components/card/card';
import { Chip } from '../../../../../../../components/chip/chip';
import { Loader } from '../../../../../../../components/loader/loader';
import { ModalProps, Modal } from '../../../../../../../components/modal/modal';
import { DeleteModal } from '../../../../../../../features/delete-modal/delete-modal';
import { CreateJobTitleModal } from './create-job-title-modal/create-job-title-modal';
import s from './job-title-modal.module.css';
import { useJobTitlesModal } from './use-job-titles-modal';

export const JobTitlesModal = (props: ModalProps) => {
  const {
    tag,
    isOpenCreateTag,
    onCloseCreateModal,
    onOpenCreateModal,
    isLoading,
    t,
    deleteTag,
    addQueryParams,
  } = useJobTitlesModal();

  return (
    <Modal {...props} title={t('Должности')}>
      <Card className={s.feature}>
        {isLoading && <Loader />}
        <ul className={s.list}>
          {tag?.map((item, index) => (
            <Chip
              onDelete={() => addQueryParams({ deleteId: item.id, deleteName: item.value })}
              key={item.id}
              data-testid={`job-title-${index}`}
            >
              {item.value}
            </Chip>
          ))}
        </ul>
        <Button fullWidth onClick={() => onOpenCreateModal()} data-testid="add-job-title-button">
          {t('Создать')}
        </Button>
        {isOpenCreateTag && <CreateJobTitleModal onClose={() => onCloseCreateModal()} />}

        <DeleteModal onSubmit={deleteTag} />
      </Card>
    </Modal>
  );
};
